import Grid from '@material-ui/core/Grid';
import React from 'react';

export default function GridItem(props) {
    const { classes, ...other } = props;
    const className = classes ? classes.root : '';
    return <Grid className={className} {...other} item={true} />;
}
